
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieCredenzialiGrid extends Serenity.EntityGrid<TipologieCredenzialiRow, any> {
        protected getColumnsKey() { return TipologieCredenzialiColumns.columnsKey; }
        protected getDialogType() { return TipologieCredenzialiDialog; }
        protected getIdProperty() { return TipologieCredenzialiRow.idProperty; }
        protected getInsertPermission() { return TipologieCredenzialiRow.insertPermission; }
        protected getLocalTextPrefix() { return TipologieCredenzialiRow.localTextPrefix; }
        protected getService() { return TipologieCredenzialiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}